<template>
  <div data-app>
    <div
      v-show="footerSelected==='profile' || footerSelected==='alertList' || footerSelected==='deviceDetail' || footerSelected==='command' || footerSelected==='playback' || footerSelected==='tracking' || footerSelected==='setPassword'"
    >
      <breadcrumb-mobile
        ref="header"
        @on-change-page="changePage"
      />
    </div>
    <div
      v-show="footerSelected==='profile'"
      class="profile-home "
    >
      <slot name="profile">
        <app-profile @on-change-page="changePageFromProfile" />
      </slot>
    </div>
    <div
      v-show="footerSelected==='dashboard'"
      class="dashboard-home "
    >
      <slot name="dashboard">
        <app-dashboard
            ref="dashboardComponent" />
      </slot>
    </div>
    <div
      v-show="footerSelected==='home'"
      class="map-home "
    >
      <slot name="map">
        <app-map
          v-if="isMobile"
          ref="homeComponent"
          @on-change-page="changePageFromMap"
        />
        <app-mapDesktop
          v-else
        />
      </slot>
    </div>
    <div
      v-if="footerSelected==='playback'"
      class="playback-home "
    >
      <slot name="playback">
        <app-playBack
          ref="playBackComponent"
        />
      </slot>
    </div>
    <div
      v-if="footerSelected==='tracking'"
      class="tracking-home "
    >
      <slot name="tracking">
        <app-tracking
          ref="trackingComponent"
        />
      </slot>
    </div>
    <div
      v-show="footerSelected==='deviceList'"
      class="deviceList-home "
    >
      <slot name="deviceList">
        <app-deviceList
          ref="deviceListComponent"
          @on-change-page="changePageFromDevicelist"
        />
      </slot>
    </div>
    <div
      v-show="footerSelected==='deviceAdd'"
      class="deviceAdd-home "
    >
      <slot name="deviceAdd">
        <app-deviceAdd
          ref="deviceAddComponent"
        />
      </slot>
    </div>
    <div
      v-show="footerSelected==='alertList'"
      class="alertList-home "
    >
      <slot name="alertList">
        <app-alertList ref="alertList" />
      </slot>
    </div>
    <div
      v-if="footerSelected==='deviceDetail'"
      class="deviceDetail-home "
    >
      <slot name="deviceDetail">
        <app-deviceDetail ref="deviceDetailComponent" />
      </slot>
    </div>
    <div
      v-if="footerSelected==='command'"
      class="command-home "
    >
      <slot name="command">
        <app-command ref="commandComponent" />
      </slot>
    </div>
    <div
      v-if="footerSelected==='setPassword'"
      class="setPassword-home "
    >
      <slot name="setPassword">
        <app-set-password />
      </slot>
    </div>

    <footer
      v-show="footerSelected!=='deviceDetail' && footerSelected!=='playback' && footerSelected!=='tracking' && footerSelected!=='command'"
      class="footer footer-home footer-light d-xl-none d-lg-none d-md-none "
    >
      <slot name="footer">
        <app-footer
          ref="footer"
          @on-update-Footer-Select="updateFooterSelect"
        />
      </slot>
    </footer>
  </div>
</template>
<script>
import AppFooter from '@core/layouts/components/AppFooter.vue'
import Vue from 'vue'
import AppDashboard from './Home/Dashboard.vue'
import AppProfile from './Home/Profile.vue'
import AppMap from './Home/Map.vue'
import AppPlayBack from './Home/PlayBack.vue'
import AppTracking from './Home/Tracking.vue'
import AppMapDesktop from './Home/MapDesktop.vue'
import AppDeviceList from './Home/DeviceList.vue'
import AppAlertList from './Home/AlertList.vue'
import AppDeviceDetail from './Home/DeviceDetail.vue'
import AppCommand from './Home/Command.vue'
import AppDeviceAdd from './Home/DeviceAdd.vue'
import AppSetPassword from './authentication/SetPassword.vue'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'


export default {
  components: {
    BreadcrumbMobile,
    AppDashboard,
    AppFooter,
    AppProfile,
    AppMap,
    AppPlayBack,
    AppTracking,
    AppMapDesktop,
    AppDeviceList,
    AppDeviceAdd,
    AppAlertList,
    AppDeviceDetail,
    AppCommand,
    AppSetPassword,
  },
  data() {
    return {
      deviceInfobottom: '-129px',
      footerSelected: 'home',
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  created() {
    // برای اینکه بار اول هیستوری خالیست و در مرحله بعدی مشکل ایجاد می کند

    Vue.prototype.$functions.deviceServerSocketReconnect(() => {})
    const $this = this
    window.onpopstate = async () => {
      if ($this.footerSelected !== 'home') {
        $this.footerSelected = 'home'
        $this.addHashToLocation('')
        // استفاده از safeRefCall برای جلوگیری از خطای undefined
        $this.safeRefCall('footer', 'tabClick', 'home')
      } else if (Vue.prototype.$productionPlatform === 'android') {
        exitFromApp()
      } else if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = 'http://127.0.0.1:3232/QXNative/?action=terminate'
        /*
        $this.footerSelected = ''
        const res = await $this.$confirm('آیا برای خروج مطمئن هستید؟', {
          title: 'پیام',
          buttonTrueText: 'بله',
          buttonFalseText: 'خیر',
          color: 'warning',
          icon: '',
        })
        if (res) {
          window.location.href = 'http://127.0.0.1:3232/QXNative/?action=terminate'
        }
        $this.footerSelected = 'home'
*/
      }
    }
  },
  mounted() {
  },
  methods: {
    // Helper method برای صدا زدن متدهای refs به صورت امن
    safeRefCall(refName, methodName, ...args) {
      const ref = this.$refs[refName]
      if (ref && typeof ref[methodName] === 'function') {
        return ref[methodName](...args)
      }
      return null
    },
    changePage(rout) {
      this.safeRefCall('footer', 'tabClick', rout)
    },
    changePageFromProfile(rout) {
      if (rout === 'setPassword') {
        this.footerSelected = 'setPassword'
        this.addHashToLocation('setPassword')
        this.safeRefCall('header', 'getTitle', 'تنظیم رمز عبور')
      }
    },
    changePageFromMap(rout, imei) {
      if (rout === 'alertList') {
        this.addHashToLocation('alertList')
        if (this.$refs.footer) {
          this.$refs.footer.selectedItem = 2
        }
        this.safeRefCall('alertList', 'doFillAlarm', imei)
        this.footerSelected = rout
        this.safeRefCall('header', 'getTitle', 'Alarms')
      }
      if (rout === 'playback') {
        this.footerSelected = 'playback'
        this.addHashToLocation('playback')
        this.safeRefCall('header', 'getTitle', 'History')
      }
      if (rout === 'tracking') {
        this.footerSelected = 'tracking'
        this.addHashToLocation('tracking')
        this.safeRefCall('header', 'getTitle', 'Tracing')
      }
      if (rout === 'detail') {
        this.footerSelected = 'deviceDetail'
        this.addHashToLocation('deviceDetail')
        this.safeRefCall('header', 'getTitle', 'Details')
      }
      if (rout === 'dashboard') {
        this.footerSelected = 'dashboard'
        this.addHashToLocation('dashboard')
        this.safeRefCall('dashboardComponent', 'doStart')
        this.safeRefCall('header', 'getTitle', '')
      }
      if (rout === 'command') {
        this.footerSelected = 'command'
        this.addHashToLocation('command')
        this.safeRefCall('header', 'getTitle', 'Commands')
      }
    },
    changePageFromDevicelist(rout, act, imei) {
      if (act === 'detail') {
        this.footerSelected = 'deviceDetail'
        this.addHashToLocation('deviceDetail')
        this.safeRefCall('header', 'getTitle', 'Details')
      }
      if (act === 'command') {
        this.footerSelected = 'command'
        this.addHashToLocation('command')
        this.safeRefCall('header', 'getTitle', 'Commands')
      }
      if (act === 'map') {
        this.footerSelected = 'home'
        this.addHashToLocation('')
        this.safeRefCall('footer', 'tabClick', rout)
        this.safeRefCall('homeComponent', 'onShowInMap', imei)
      }
      if (act === 'history') {
        this.footerSelected = 'playback'
        this.addHashToLocation('playback')
        Vue.prototype.$selectDevicePlayBack = imei
        this.safeRefCall('playBackComponent', 'onMobileMapShowHistoryBar')
      }
    },
    updateFooterSelect(v) {
      this.footerSelected = v
      if (v === 'deviceList') {
        this.addHashToLocation('deviceList')
        this.safeRefCall('deviceListComponent', 'doFillDevices')
      }
      if (v === 'dashboard') {
        this.addHashToLocation('dashboard')
        this.safeRefCall('dashboardComponent', 'doStart')
        this.safeRefCall('header', 'getTitle', '')
      }
      if (v === 'profile') {
        this.addHashToLocation('profile')
        this.safeRefCall('header', 'getTitle', 'Profile')
      }
      if (v === 'alertList') {
        this.addHashToLocation('alertList')
        this.safeRefCall('header', 'getTitle', 'Alarms')
        this.safeRefCall('alertList', 'doFillAlarm', null)
      }
      if (v === 'home') {
        this.addHashToLocation('')
      }
    },
    addHashToLocation(params) {
      // eslint-disable-next-line no-param-reassign
      if (params !== '') params = `#!${encodeURIComponent(params)}`
      // eslint-disable-next-line no-restricted-globals
      history.pushState(
        {},
        null,
        `${this.$route.path}${params}`,
      )
    },
  },
}
</script>
<style>
.footer-fixed footer{
  z-index: 999 !important;
}
</style>
